<template>
  <div class="contaier">
    <!-- <div class="demo-content">
      <div class="btns">
        <button @click="prev">上一页</button>
        <button @click="next">下一页</button>
      </div>
    </div> -->

    <div class="indicator-view">
      <div
        class="bar-scroll-wrap"
        :style="{ transform: `translateX(${scrollOffset}px)` }"
      >
        <div
          v-for="(item, idx) in totalCount"
          :key="idx"
          class="bar"
          :class="{ active: idx === currentIndex }"
        ></div>
        <!-- @click="currentIndex = idx" -->
      </div>
    </div>
    <div class="page-text" >{{ currentIndex + 1 }}/{{ totalCount }}</div>
  </div>
</template>

<script>
export default {
  name: "CenterIndicator",
  props: {
    totalCount: {
      type: Number,
      default: 6,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // currentIndex: 0,
      barWidth: 2, //竖杆宽度
      barGap: 14, //竖杆间距
      scrollOffset: 0,
    };
  },
  watch: {
    currentIndex() {
      this.calcOffset();
    },
  },
  mounted() {
    this.calcOffset();
  },
  methods: {
    // prev() {
    //   if (this.currentIndex > 0) {
    //     this.currentIndex--;
    //   }
    // },
    // next() {
    //   if (this.currentIndex < this.totalCount - 1) {
    //     this.currentIndex++;
    //   }
    // },
    // 计算位移，让激活项保持在可视窗口正中间
    calcOffset() {
      // 每根竖杆+间隙总占位
      const itemSpace = this.barWidth + this.barGap;
      // 需要向左偏移距离：把激活项挪到视口中心
      const halfView = (itemSpace * 2) / 2;
      const targetX = -(this.currentIndex * itemSpace) + halfView;

      this.scrollOffset = targetX;
    },
  },
};
</script>

<style lang="scss" scoped>
.contaier {
  // padding-top: 10px;
  width: calc(2 * (3px + 16px));
  height: 84px;
  margin: 0 auto;
  overflow: hidden;
  color: #000;
  position: relative;
  z-index: 9999;
  display: flex;
}
.demo-content {
  margin-bottom: 30px;
}
.btns button {
  margin: 0 8px;
  padding: 6px 12px;
}

/* 可视窗口：固定宽度，溢出隐藏，只能看到中间3根 */
.indicator-view {
  padding-top: 40px;
}
/* 可滚动容器，横向位移实现居中效果 */
.bar-scroll-wrap {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  transition: transform 0.24s ease;
}

.bar {
  width: 2px;
  height: 8px;
  background: rgba(000, 000, 000, 0.6);
  cursor: pointer;
  transition: all 0.24s ease;
  flex-shrink: 0;
}
.bar.active {
  width: 3px;
  height: 12px;
  background: #000;
}

.page-text {
  width: 100%;
  position: absolute;
  bottom: 0;
  text-align: center;
  // margin-top: 10px;
  font-size: 14px;
}
</style>
